<a
  [routerLink]="['/admin', 'program', programId]"
  type="button"
  class="btn btn-primary d-block"
  ><fa-icon [icon]="faEdit" title="Edit"></fa-icon
></a>
